import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import DesignersProductPerformanceDataGrid from 'components/reports/designers/DesignersProductPerformanceDataGrid';
import PriceBreakDownFilter from 'components/reports/products/priceBreakDown/PriceBreakDownFilter';
import { toast } from 'react-toastify';
import {
  convertQueryParamsIntoObject,
  convertObjectIntoQueryParams,
  dateFormat,
} from 'constant/Helpers';
import cloneDeep from 'lodash/cloneDeep';
// actions
import { setLoaderOpenTrue, setLoaderOpenFalse } from 'store/app/AppActions';
import { setDesignerslistData } from 'store/reports/ReportsActions';
// selectors
import { getDesignersListData } from 'store/reports/ReportsSelectors';
// api
import DesignersReportService from 'services/reportsService/DesignersReportService';
// datadog
import { errorLogger } from 'datadog/DDUtils';

const DesignersProductPerformancePage = () => {
  const [data, setData] = useState([]);
  const [inputValues, setInputValues] = useState({
    fromDate: dateFormat(new Date()),
    toDate: dateFormat(new Date()),
    designer: 0,
  });
  const designersList = useSelector((state) => getDesignersListData({ state }));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const fetchData = async (params) => {
    dispatch(setLoaderOpenTrue());
    try {
      const res = await DesignersReportService.getDesignersProductPerformance(params);
      setData(res.data);
      dispatch(setLoaderOpenFalse());
    } catch (err) {
      errorLogger('Designer Product Report Page Fetch Data Error:', err);
      dispatch(setLoaderOpenFalse());
      toast.error('Failed to get data!!');
    }
  };

  useEffect(() => {
    if (location.search) {
      const queryObj = convertQueryParamsIntoObject(location.search);
      fetchData(queryObj);
    } else {
      fetchData(inputValues);
    }
    dispatch(setDesignerslistData());
  }, []);

  const handleSubmit = async () => {
    const updatedParams = cloneDeep(inputValues);
    const queryString = convertObjectIntoQueryParams(updatedParams);
    navigate({
      pathname: '/report/DesignersProductPerformance',
      search: queryString,
    });
    fetchData(updatedParams);
  };

  const handleExport = async () => {
    try {
      const updatedParams = cloneDeep(inputValues);
      updatedParams.fromDate = inputValues.fromDate;
      updatedParams.toDate = inputValues.toDate;
      const res = await DesignersReportService.exportGetDesignersProductPerformance(updatedParams);
      toast.success(res?.data?.message);
    } catch (err) {
      errorLogger('Designer Product Report Page Export Data Error:', err);
      toast.error('Failed to export excel file!!');
    }
  };

  return (
    <div className="toolbar-table-style">
      <PriceBreakDownFilter
        inputValues={inputValues}
        setInputValues={setInputValues}
        handleSubmit={handleSubmit}
        title="Designers Product Performance"
        designers
        designersList={designersList}
        hasExport
        handleExport={handleExport}
        defaultDate
      />
      <DesignersProductPerformanceDataGrid data={data} />
    </div>
  );
};

export default DesignersProductPerformancePage;
